import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TCohortStatistics = {
    created?: string;
    showTargets: boolean;
    showIncluded: boolean;
    includedMembers?: number;
    targetedMembers?: number;
    includedCareGaps?: number;
    targetedCareGaps?: number;
};

export interface ICohortDefinitionsMetadataState {
    statistics: TCohortStatistics;
}

const initialState: ICohortDefinitionsMetadataState = {
    statistics: {
        showTargets: false,
        showIncluded: false,
        includedMembers: 0,
        includedCareGaps: 0,
        targetedCareGaps: 0,
        targetedMembers: 0,
    },
};

const reducerObject = createSlice({
    name: "cohortDefinitionMetadata",
    initialState,
    reducers: {
        setStatistics(state: ICohortDefinitionsMetadataState, action: PayloadAction<TCohortStatistics>) {
            return { ...state, statistics: { ...state.statistics, ...action.payload } };
        },
    },
});

export const { setStatistics } = reducerObject.actions;

export default reducerObject.reducer;
